class SideCartUpsell {
  constructor() {
    this.init();
  }

  init = () => {
    this.clickEvent();
    this.selectChangeEvent();
  };

  clickEvent = () => {
    document.addEventListener("click", (event) => {
      const addToCartBtn = event.target.closest(".mini-cart__upsell-product-btn-wrapper button[variant-id]");
      if (addToCartBtn) {
        event.preventDefault();
        event.stopPropagation();
        const variantId = addToCartBtn.getAttribute("variant-id");
        this.addToCart(variantId);
      }
    });
  };

  handleCountUpdate = () => {
    const cartCountElement = document.querySelector(".header__cart-toggle .header__cart-count");
    if (cartCountElement) {
      fetch("/cart.js")
        .then((response) => response.json())
        .then((cart) => {
          setTimeout(() => {
            cartCountElement.innerHTML = cart.item_count;
          }, 300);
        })
        .catch(() => {
          alert("Error");
        });
    }
  }

  addToCart = (variantId) => {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then((response) => response.json())
      .then(() => {
        this.handleCountUpdate()
        window.onCartRefresh()
      })
      .catch(() => {
        alert("Error");
      });
  };

  selectChangeEvent = () => {
    document.addEventListener("change", (event) => {
      const selectElement = event.target.closest(".mini-cart__upsell-product-variant-select");
      const productPrice = document.querySelectorAll(".mini-cart__upsell-product-price");
      const productCompareAtPrice = document.querySelectorAll(".mini-cart__upsell-product-compare-at-price");
      const actionButton = document.querySelector(".mini-cart__upsell-product-btn-wrapper button");
      if (selectElement) {
        const selectedOption = selectElement.options[selectElement.selectedIndex];
        const selectedVariantId = selectedOption.getAttribute("data-id");

        actionButton.setAttribute("variant-id", selectedVariantId);

        productPrice.forEach(price => {
          const productPrice = price.getAttribute("data-id");
          if (productPrice == selectedVariantId) {
            price.classList.add("active");
          } else {
            price.classList.remove("active");
          }
        });

        productCompareAtPrice.forEach(price => {
          const productCompareAtPrice = price.getAttribute("data-id");
          if (productCompareAtPrice == selectedVariantId) {
            price.classList.add("active");
          } else {
            price.classList.remove("active");
          }
        });
      }
    });
  };
}

new SideCartUpsell();